import { Form } from 'antd';
import { JSX } from 'react';
import BCLoading from '../../BCLoading';
import { FormLayout, IFormProps } from '../entities';

//validation helper => Utils/validationHelper in components

const BCForm = (props: IFormProps) => {
	const { formRef, showLoading, ...formProps } = props;

	const renderForm = (): JSX.Element => (
		<Form
			ref={formRef}
			{...formProps}
		>
			{props.children}
		</Form>
	);

	return (
		<>
			{showLoading ? (
				<BCLoading
					show={showLoading}
					delay={500}
				>
					{renderForm()}
				</BCLoading>
			) : (
				renderForm()
			)}
		</>
	);
};
export default BCForm;
export { FormLayout, IFormProps };
